import { useEffect, useState } from "react";
import { buscarCotaUsuarioByIdService } from "../../../services/buscarCotaUsuarioByIdService";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";

export const useBuscarCotaUsuario = (cotaUsuarioId: number | null) => {
  const [cotaUsuario, setCotaUsuario] = useState<CotaUsuario | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const fetch = async () => {
    if (cotaUsuarioId) {
      setLoading(true);
      try {
        const data = await buscarCotaUsuarioByIdService(cotaUsuarioId);
        if (data) {
          setCotaUsuario(data);
        }
      } catch (err) {
        console.error("Erro ao buscar cotaUsuario:", err);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, [cotaUsuarioId]);

  return { cotaUsuario, loading };
};
